import RequestContextService from '../RequestContextService.js';
import getBaseUrl from './getBaseUrl.js';

export default async function refreshAuthToken() {
  const baseUrl = getBaseUrl();
  const csrf = getCookie('csrf');
  const requestContext = RequestContextService.get();

  const response = await fetch(`${baseUrl}/authentication-refresh-token`, {
    headers: {
      Accept: 'application/json',
      'Accept-encoding': 'gzip',
      'Content-type': 'application/json; charset=UTF-8',
      ...(csrf && { 'X-CSRF-Token': csrf })
    },
    method: 'POST',
    keepalive: true,
    body:
      requestContext && requestContext.refreshToken
        ? JSON.stringify({ refreshToken: requestContext.refreshToken })
        : undefined
  });

  if (!response.ok) {
    throw Object.assign(
      new Error(`Error while refreshing authToken : ${response.status} ${response.statusText}`),
      { status: response.status }
    );
  }

  const { authToken, authTokenExpirationDate, refreshToken } = await response.json();
  return { authToken, authTokenExpirationDate, refreshToken };
}

function getCookie(name) {
  const parts = `; ${document.cookie}`.split(`; ${name}=`);
  return parts.length === 2 ? parts.pop().split(';').shift() : undefined;
}
